<div *ngIf="addresses?.length && hasAddress" class="addressBookContainer mb-10">
  <ngb-accordion activeIds="custom-panel-1">
    <ngb-panel id="custom-panel-1">
      <ng-template ngbPanelHeader let-opened="opened">
        <h4 class="d-none d-lg-block">{{ 'habaAddressBook.headline' | cxTranslate }}</h4>
        <button
          [attr.data-qa]="qaToggle?.getButtonId()"
          class="btn-primary d-lg-none w-100 border-0 bg-transparent d-flex align-items-center justify-content-between p-0"
          ngbPanelToggle
        >
          <div class="d-flex align-items-center">
            <h4>{{ 'habaAddressBook.headline' | cxTranslate }}</h4>
          </div>
          <app-svg class="pr-3" dimension="0.8em" [iconName]="opened ? 'Minus' : 'Plus'"></app-svg>
        </button>
      </ng-template>
      <ng-template ngbPanelContent>
        <ng-container *ngTemplateOutlet="addressesTemplate"></ng-container>
      </ng-template>
    </ngb-panel>
  </ngb-accordion>
</div>

<ng-template #addressesTemplate>
  <ng-container *ngFor="let address of addresses; let i = index">
    <div class="p-8 bg-white mb-6">
      <div class="row">
        <div class="col">
          <div class="mb-3">
            <div *ngIf="address.addressType === CustomerType.private; else companyName">
              <strong [attr.data-qa]="nameTextQaId.getTextId() + '-' + i">
                {{ address.titleCode === titleCode.NONE ? '' : address.title }}
                {{ address.firstName }} {{ address.lastName }}
              </strong>
            </div>
            <ng-template #companyName>
              <strong [attr.data-qa]="companyNameTextQaId.getTextId() + '-' + i">
                {{ address.companyName }}
              </strong>
            </ng-template>
          </div>
          <div class="mb-3" [attr.data-qa]="phoneTextQaId.getTextId() + '-' + i">
            {{ 'habaAddressBook.phoneLabel' | cxTranslate }} {{ address.phone }}
          </div>
          <div
            class="mb-3"
            *ngIf="address.additionalInfo"
            [attr.data-qa]="additionalInfoTextQaId.getTextId() + '-' + i"
          >
            {{ address.additionalInfo }}
          </div>
          <div class="mb-3" [attr.data-qa]="streetNameAndNumberTextQaId.getTextId() + '-' + i">
            {{ address.line1 }} {{ address.line2 }}
          </div>
          <div class="mb-3" [attr.data-qa]="postalCodeAndCityTextQaId.getTextId() + '-' + i">
            {{ address.postalCode }} {{ address.town }}
          </div>
          <div>{{ address.country.name }}</div>
        </div>
      </div>
      <div class="row">
        <div
          class="col-12 col-md-6 d-flex flex-column justify-content-end"
          [ngClass]="{
            'mt-7': address.billingAddress || (address.contactAddress && address.shippingAddress),
          }"
        >
          <div *ngIf="address.billingAddress">
            <strong [attr.data-qa]="defaultBillingTextQaId.getTextId()">{{
              'habaAddressBook.isBillingAddress' | cxTranslate
            }}</strong>
          </div>
          <div *ngIf="address.contactAddress && address.shippingAddress">
            <strong [attr.data-qa]="defaultShippingTextQaId.getTextId()">
              {{ 'habaAddressBook.isDefaultDeliveryAddress' | cxTranslate }}</strong
            >
          </div>
        </div>
        <div class="col-12 col-md-6 mt-8">
          <button
            class="btn btn-primary btn-full"
            type="button"
            [attr.data-qa]="qaApply?.getButtonId() + '-' + i"
            size="small"
            (click)="takeAddress(address)"
          >
            <span appButtonText>{{ 'habaAddressBook.updateAddress' | cxTranslate }}</span>
          </button>
        </div>
      </div>
    </div>
  </ng-container>
</ng-template>
